import {Component, OnDestroy, OnInit} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder} from '@angular/forms';
import { Account } from '../account';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../account.service';
import { UpdatePassword } from '../UpdatePassword';
import { TranslateService } from '@ngx-translate/core';
import { passwordValidator } from '../passwordValidator';
import {Localization} from '../../common/enums/localization';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  providers: [AccountService]
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  public accountConfirmGroup: UntypedFormGroup;
  public sub: any;
  public culture: any;
  public resetPasswordCode: string;
  public account: Account;
  public translationCompleted: boolean;
  public resetPasswordProcessing: boolean = true;
  public readonly Localization = Localization;

  constructor(private formBuilder: UntypedFormBuilder, private route: ActivatedRoute, private router: Router,
              private accountService: AccountService, private translate: TranslateService) {
  }

  ngOnInit() {
    this.translationCompleted = false;
    this.sub = this.route.params.subscribe(params => {
      this.culture = params['culture'];
      this.resetPasswordCode = params['resetPasswordCode'];
      this.culture = this.culture == null ? 'en-US' : this.culture;
      this.translate.onLangChange.subscribe(() => this.translationCompleted = true);
      this.translate.use(this.culture);
      this.resetPasswordProcessing = true;
      this.accountService.checkResetPasswordCode(this.resetPasswordCode).subscribe(
        (res) => this.resetPasswordProcessing = false,
        err => this.router.navigate(['error-page']),
      );
    });

    this.accountConfirmGroup = this.formBuilder.group({
      password: [],
      passwordConfirm: [],
      newPasswordRequired: []
    }, { validator: passwordValidator });
    this.accountConfirmGroup.get('newPasswordRequired').setValue(true);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  resetPassword() {
    if (this.accountConfirmGroup.valid) {
      this.resetPasswordProcessing = true;
      const updatePassword = new UpdatePassword(this.resetPasswordCode, this.accountConfirmGroup.get('password').value);
      this.accountService.confirmForgotPassword(updatePassword).subscribe(
        res => {
          this.router.navigateByUrl('/account?resetpassword=true');
        });
    }
  }
}
